import React from "react";
import "./photo-column.scss";

interface PhotoColumnProps {
    imageSource?: any;
    imageTitle: string;
    isImageBordered?: boolean;
    figcaptionFirstTitle?: string | any;
    figcaptionSecondTitle?: string;
    className?: string;
    width?: number;
    isImgSourceChange?: boolean;
    imageSourceList?: ImageSourceListType[];
    figcaptionColor?: string;
    figcaptonFontWeight?: number | string;
    isTextOverImage?: boolean;
    imageOverlyTextFirst?: string;
    imageOverlyTextSecond?: string;
}

interface ImageSourceListType {
    src: any,
    width: number
}
export const PhotoColumn = (props: PhotoColumnProps) => {
    const handleContextMenu = (e: any) => {
        e.preventDefault();
    }

    let miniSource: any;
    let largeSource: any;

    if (props.isImgSourceChange && props.imageSourceList) {
        miniSource = props.imageSourceList[0];
        largeSource = props.imageSourceList[1];
    }

    return (
        <div className={props.className ? `photo-column ${props.className}` : "photo-column"} onContextMenu={handleContextMenu}>
            <figure>
                {
                    props.isImgSourceChange ?
                        <img
                            src={largeSource}
                            alt={props.imageTitle}
                            srcSet={`${miniSource.src} ${miniSource.width}w, ${largeSource.src} ${largeSource.width}w`}
                            sizes={`(max-width: 600px) ${miniSource.width}px,  ${largeSource.width}px`}
                        />
                        :
                        props.isTextOverImage ?
                            <div className="img-container">
                                <img src={props.imageSource} alt={props.imageTitle} width={props.width ?? "auto"} />
                                <div className="overlay_top-left">{props.imageOverlyTextFirst}</div>
                                <div className="overlay_bottom-right">{props.imageOverlyTextSecond}</div>
                            </div>
                            : <img src={props.imageSource} alt={props.imageTitle} width={props.width ?? "auto"} />
                }
                {
                    props.figcaptionFirstTitle &&
                    <figcaption className="figcaption-text" style={{ color: props.figcaptionColor, fontWeight: props.figcaptonFontWeight }}>
                        {props.figcaptionSecondTitle ?
                            <>
                                {props.figcaptionFirstTitle} <br />
                                {props.figcaptionSecondTitle}
                            </>
                            :
                            <>
                                {props.figcaptionFirstTitle}
                            </>
                        }
                    </figcaption>
                }
            </figure>
        </div>
    )
}

PhotoColumn.defaultProps = {
    figcaptionColor: "",
};